import { useEffect, useCookies, useHideSolvvy } from 'sb-hooks'
import { constants } from 'common/helpers'
import { useConnect } from 'sb-redux-hook'


// This hook using for entry points from site app.
// All entry points for marketing should be have this hook.
// This Important!

type CookiesType = {
  [key: string]: any
}

type OptionsType = {
  skip?: boolean
  withReferrerUrl?: boolean
  withLogoRedirectUrl?: boolean
}

const cookiesToDelete = [
  constants.cookieNames.offer,
  constants.cookieNames.fbPixel,
  constants.cookieNames.selectedPlan,
  constants.cookieNames.authCountdown,
  constants.cookieNames.discountCoupon,
  constants.cookieNames.makeupIntroFlow,
  constants.cookieNames.logoRedirectUrl,
  constants.cookieNames.skincareIntroFlow,
  constants.cookieNames.isFreeTrialCoupon,
  constants.cookieNames.newPaymentCouponCode,
  constants.cookieNames.mainPageThxNotification,
]

const useLanding = (cookies?: CookiesType, options?: OptionsType) => {
  useHideSolvvy()

  const { withLogoRedirectUrl = true, withReferrerUrl = true, skip } = options || {}

  const { removeCookie, setCookie } = useCookies()

  const { pathname } = useConnect({
    pathname: 'routing.location.pathname',
  })

  useEffect(() => {
    if (skip) {
      return
    }

    cookiesToDelete.forEach((cookieName) => {
      removeCookie(cookieName)
    })

    if (cookies) {
      Object.keys(cookies).forEach((cookieName) => {
        const cookieValue = cookies[cookieName]

        setCookie(cookieName, cookieValue)
      })
    }

    if (withLogoRedirectUrl) {
      setCookie(constants.cookieNames.logoRedirectUrl, pathname)
    }

    if (withReferrerUrl) {
      const url = encodeURI(`${window.location.hostname.replace(/^www\./, '')}${pathname}`)

      setCookie(constants.cookieNames.referrerLandingPageURL, url, { encode: false })
    }
  }, [ pathname, cookies, skip, withLogoRedirectUrl, withReferrerUrl ])
}


export default useLanding
